import React from "react";
import { Heading } from "../../design/heading";
import EmptyStateView from "../../components/EmptyStateView";
import ErrorView from "../../components/ErrorView";
import LoadingView from "../../components/LoadingView";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import { useMonthlyExpenseSummary } from "../../contexts/MonthlyExpenseSummaryContext";
import MonthlyExpenseSummaryListItem from "./MonthlyExpenseSummaryListItem";
import RefreshButton from "../FinancialTransactionListPage/components/RefreshButton";
import PlaidButton from "../../components/PlaidButton";

const MonthlyExpenseSummaryListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { monthlyExpenseSummaries, loading, error } =
    useMonthlyExpenseSummary();

  if (loading.list) {
    return <LoadingView title="Loading Monthly Expenses..." />;
  }

  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between gap-4 mb-6">
        <Heading className="text-2xl font-bold">Monthly Expenses</Heading>
        <RefreshButton type="monthly_expenses" />
      </div>
      {monthlyExpenseSummaries.length === 0 ? (
        <EmptyStateView
          title="No Monthly Expense Summaries"
          message="No monthly expense summaries found for this matter."
          action={<PlaidButton>Integrate Accounts</PlaidButton>}
        />
      ) : (
        <div className="space-y-4">
          {monthlyExpenseSummaries.map((summary) => (
            <MonthlyExpenseSummaryListItem
              key={summary._id}
              monthlyExpenseSummary={summary}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MonthlyExpenseSummaryListPage;
